export const toTwitter = (str?: unknown): string | undefined => {
    if (typeof str !== 'string') return undefined;

    const trimmed = str.trim();
    if (trimmed === '') return undefined;
    if (trimmed.startsWith('@')) return trimmed;

    return `@${trimmed}`;
};
